import { render, staticRenderFns } from "./DetalleAgendamiento.vue?vue&type=template&id=38f5f70c&"
import script from "./DetalleAgendamiento.vue?vue&type=script&lang=js&"
export * from "./DetalleAgendamiento.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAgendamiento.vue?vue&type=style&index=0&id=38f5f70c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports